export const nutritionJournalList = [
	{
		id: "protein_calories",
		icon: "icon icon-calories",
		color: ["#A38CE2", "#6C72B6"],
		text_color: "#606DAC",
		label: "protein calories",
		shadow: "0 2px 4px 0 rgba(0,0,0,0.24)"
	},
	{
		id: "vegetable",
		icon: "icon icon-veggies",
		color: ["#81DBD8", "#199190"],
		text_color: "#27A8A7",
		label: "servings of veggies",
		shadow: "0 2px 4px 0 rgba(0,0,0,0.24)"
	},
	{
		id: "fruit",
		icon: "icon icon-fruits",
		color: ["#EF63B0", "#9F3285"],
		text_color: "#9F3285",
		label: "servings of fruits",
		shadow: "0 2px 4px 0 rgba(0,0,0,0.24)"
	},
	{
		id: "fat",
		icon: "icon icon-fat",
		color: ["#FDB959", "#FF7051"],
		text_color: "#FF7651",
		label: "servings of fat",
		shadow: "0 2px 4px 0 rgba(0,0,0,0.24)"
	},
	{
		id: "misc",
		icon: "icon icon-misc",
		color: ["#FF7777", "#D54C4C"],
		text_color: "#D54C4C",
		label: "servings of misc",
		shadow: " 0 2px 4px 0 rgba(0,0,0,0.24)"
	},
	{
		id: "starch",
		icon: "icon icon-starch",
		color: ["#C2DB71", "#46A061"],
		text_color: "#46A061",
		label: "servings of starch",
		shadow: "0 2px 4px 0 rgba(0,0,0,0.24)"
	},
	{
		id: "dairy",
		icon: "icon icon-dairy",
		color: ["#6E90EE ", "#2A4F8C "],
		text_color: "#2A4F8C ",
		label: "servings of dairy",
		shadow: " 0 2px 4px 0 rgba(0,0,0,0.24)"
	}
];
